import { defineAsyncComponent } from 'vue';

// Drive's eager slice for the Connect shell (`@drive/connect/shell`, I-1786).
// The shell provides the Drive file picker to every app through `DriveServiceKey`
// — a write field stores its pictures through it, so it has to exist before
// anyone opens Drive itself. Only the handle is eager; the dialog component is
// behind a dynamic import so the shell's startup graph stays small.

export { createDriveFilePicker } from '@/picker/createDriveFilePicker';
export { fetchDriveFormats } from '@/api/drive';
export type { DriveFilePickerHandle } from '@/picker/createDriveFilePicker';

export const DriveFilePicker = defineAsyncComponent(
  () => import('@/picker/DriveFilePicker.vue')
);
